import { Toaster as Sonner, toast as sonnerToast } from "sonner"
import { useSettings } from "../../context/SettingsContext"

const CopyIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
    <path d="M3 8H2a1 1 0 01-1-1V2a1 1 0 011-1h5a1 1 0 011 1v1" stroke="currentColor" strokeWidth="1.2"/>
  </svg>
);

const withCopy = (message, opts = {}) => {
  const text = typeof message === "string" ? message : "";
  return sonnerToast(
    <span style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
      <span style={{ flex: 1 }}>{message}</span>
      {text && (
        <button
          onClick={e => {
            e.stopPropagation();
            navigator.clipboard?.writeText(text).then(() => sonnerToast("Copied!", { duration: 1200 }));
          }}
          className="crescendo-toast-copy-btn"
          style={{ opacity: 0, background: "none", border: "none", cursor: "pointer", color: "#52525B", padding: "2px 4px", borderRadius: 4, flexShrink: 0, transition: "opacity 0.15s, color 0.15s" }}
          onMouseEnter={e => { e.currentTarget.style.opacity="1"; e.currentTarget.style.color="#EDEDED"; }}
          onMouseLeave={e => { e.currentTarget.style.opacity="0"; }}
          title="Copy"
        >
          <CopyIcon/>
        </button>
      )}
    </span>,
    opts
  );
};

const toast = Object.assign(
  (msg, opts) => withCopy(msg, opts),
  {
    success: (msg, opts) => withCopy(msg, opts),
    error: (msg, opts) => sonnerToast.error(msg, opts),
    info: (msg, opts) => withCopy(msg, opts),
    warning: (msg, opts) => withCopy(msg, opts),
    loading: (...a) => sonnerToast.loading(...a),
    dismiss: (...a) => sonnerToast.dismiss(...a),
    promise: (...a) => sonnerToast.promise(...a),
  }
);

const Toaster = ({ ...props }) => {
  const settings = useSettings?.();
  const maxToasts = Math.min(3, settings?.maxNotifications ?? 3);
  const themePref = settings?.theme === "light" ? "light" : "dark";
  return (
    <Sonner
      theme={themePref}
      position="bottom-right"
      offset={24}
      expand
      visibleToasts={maxToasts}
      closeButton
      duration={3000}
      className="toaster group crescendo-toaster"
      toastOptions={{
        duration: 3000,
        classNames: {
          toast: "group toast crescendo-toast crescendo-toast-clickable group-[.toaster]:bg-[#141414] group-[.toaster]:text-[#EDEDED] group-[.toaster]:border-[#2A2A2A] group-[.toaster]:shadow-xl",
          description: "group-[.toast]:text-[#A1A1AA]",
          actionButton: "group-[.toast]:bg-[#5A90F5] group-[.toast]:text-white",
          cancelButton: "group-[.toast]:bg-[#1a1a1a] group-[.toast]:text-[#A1A1AA]",
          closeButton: "crescendo-toast-close",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast }
